export * from './named-template.component';
export * from './named-template.module';
